<template>
	<section class="social" :class="$i18n.locale">
		<img
			src="@/assets/img/sharing-bg.png"
			alt
			class="social-bg"
			aria-hidden="true"
			role="presentation"
		/>
		<div class="container">
			<div class="content-text">
				<h2
					v-html="$t('Social.title')"
					v-wow="{
						'animation-name': 'fadeInUp',
						'animation-duration': '1s',
					}"
				></h2>
				<p
					v-html="$t('Social.description')"
					v-wow="{
						'animation-name': 'fadeInUp',
						'animation-duration': '1s',
						'animation-delay': '0.3s',
					}"
				></p>
			</div>

			<div
				class="content-articles"
				v-match-heights="{
					el: ['.article-text'],  // Array of selectors to fix
					disabled: [767]
				}"
			>
				<Article
					v-for="(article, index) in articles"
					:key="index"
					:article="article"
					v-wow="{
						'animation-duration': '1s',
					}"
				/>
			</div>

			<Button
				:title="$t('Common.button.title')"
				:url="$t('Common.button.url')"
				target="_blank"
				size="big"
				v-wow="{
					'animation-name': 'fadeInUp',
					'animation-duration': '1s',
					'animation-delay': '0.3s',
				}"
			/>
		</div>
	</section>
</template>

<script>
import Article from '../partials/Article.vue'
import Button from '../partials/Button.vue'
export default {
	name: 'Social',
	components: {
		Article,
		Button,
	},
	computed: {
		articles() {
			return this.$t('Social.articles')
		},
	},
	mounted() {
		setTimeout(function() {
			// We trigger a resize for Vue Match Heights to correctly re-trigger
			window.dispatchEvent(new Event('resize'))
		}, 300)
	},
}
</script>

<style scoped lang="scss">
.social {
	padding: 0 0 70px;

	.social-bg {
		position: absolute;
		top: -426px;
		width: 1200px;
		left: -309px;
	}

	.container {
		max-width: 1435px;
	}

	.content-text {
		text-align: center;

		p {
			max-width: 690px;
			margin: 20px auto 0;
		}
	}

	.content-button {
		text-align: center;
		margin-top: 40px;
	}
}

.content-articles {
	@include flex-container(center);
	margin-top: 30px;
}

@include tabletLandscape {
	.social {
		padding-top: 78px;
	}
}

@include tabletPortrait {
	.social {
		background: none;
		padding: 20px 0 40px;
		margin-top: 0;
	}
}

@include mobile {
	.content-text {
		h2 {
			margin-bottom: 20px;
		}
	}
}
</style>
